/**
 * groupVolumeRelation模块接口列表
 */
import $http from '../utils/http'; // 导入http中创建的axios实例

const groupVolumeRelation = {
  // 增加GroupVolumeRelation
  createVolumeRelation(params) {
    return $http.post(`${global.API_URL}/sme/groupVolumeRelation/create`,params);
  },
  //根据组ID查询卷
  queryVolumeByGroupId(params) {
    return $http.post(`${global.API_URL}/sme/groupVolumeRelation/queryVolumeByGroupId`,params);
  },
  //根据groupId和VolumeId删除GroupVolumeRelation模块
  deleteByGroupIdAndVolumeId(params) {
    return $http.post(`${global.API_URL}/sme/groupVolumeRelation/deleteByGroupIdAndVolumeId`,params);
  },
  //查询当前用户可以查看卷
  queryVolumeByGroup(params) {
    return $http.post(`${global.API_URL}/sme/groupVolumeRelation/queryVolumeByGroup`,params);
  }
}

export default groupVolumeRelation;



// WEBPACK FOOTER //
// ./src/api/groupVolumeRelation.js